import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FopContent from '../../containers/fopPartials/FopContent';
import ProductLabel from '../../../products/models/ProductLabel';
import FopQuickMenu from '../../containers/FopQuickMenu';
import { generateLocationRelatedData } from 'apps/analytics/utils/basketQuantityUpdateStatistics';

import { getCitrusAdData } from 'apps/analytics/utils/citrusAd';
import CriteoFopAnalytics from '[theme-lib]/apps/analytics/containers/CriteoFopAnalytics';

export default class RegularFopView extends PureComponent {
  static propTypes = {
    analyticsDataBasketItems: PropTypes.any,
    className: PropTypes.string,
    collectionFopIdx: PropTypes.number,
    fop: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      hash: PropTypes.number.isRequired,
      fopAttributes: PropTypes.object,
    }),
    fopElementsFactory: PropTypes.shape({
      getFopControlsComponent: PropTypes.func.isRequired,
      hasQuickMenu: PropTypes.bool.isRequired,
      getFopAnalyticsComponents: PropTypes.func.isRequired,
      getFopMiddleContent: PropTypes.func.isRequired,
    }).isRequired,
    fopType: PropTypes.string,
    isCitrusAdAnalyticsEnabled: PropTypes.bool,
    isCriteoAdEnabled: PropTypes.bool,
    product: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      labels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
      price: PropTypes.object.isRequired,
      offer: PropTypes.object,
      valueDelivered: PropTypes.bool,
    }),
    productGtmData: PropTypes.object,
    productsPageRoute: PropTypes.object.isRequired,
    promotionGtmData: PropTypes.object,
    section: PropTypes.object,
    sectionFopIdx: PropTypes.number,
    sectionIdx: PropTypes.number,
    pageParameters: PropTypes.object,
  };

  getCitrusAdData = () => {
    const { isCitrusAdAnalyticsEnabled, fop } = this.props;
    const { fopAttributes } = fop;
    this.citrusAdData = this.citrusAdData
      || getCitrusAdData({ fopAttributes, shouldReport: isCitrusAdAnalyticsEnabled });

    return this.citrusAdData;
  };

  render() {
    const {
      analyticsDataBasketItems,
      className,
      collectionFopIdx,
      fop,
      fopElementsFactory,
      fopType,
      isCriteoAdEnabled,
      product,
      productGtmData,
      productsPageRoute,
      promotionGtmData,
      section,
      sectionFopIdx,
      sectionIdx,
      pageParameters,
    } = this.props;

    const collectionOrderDetails = {
      fopInCollection: collectionFopIdx,
      fopInSection: sectionFopIdx,
      sectionInCollection: sectionIdx,
    };

    const citrusAdData = this.getCitrusAdData();

    return (
      <div
        className={classNames(
          'fop-item',
          className,
          { 'fop-item-offer': product.offer },
        )}
        data-sku={product.sku}
      >
        {fopElementsFactory.getFopAnalyticsComponents({ fopType, product, fop, section, collectionOrderDetails })}
        <FopContent
          citrusAdData={citrusAdData}
          fopMiddleContent={
            fopElementsFactory.getFopMiddleContent(
              {
                isValueDeliveredProduct: product.valueDelivered,
                labels: product.labels,
                price: product.price,
                sku: product.sku,
              }
            )
          }
          product={product}
          productGtmData={productGtmData}
          promotionGtmData={promotionGtmData}
          pageParameters={pageParameters}
        />
        {fopElementsFactory.getFopControlsComponent({
          product,
          section,
          analyticsContextData: {
            analyticsDataBasketItems,
            productsPageRouteLocationQuery: generateLocationRelatedData(productsPageRoute),
            externalAdData: citrusAdData,
          },
          collectionFopIdx,
        })}
        {fopElementsFactory.hasQuickMenu && (
          <FopQuickMenu
            product={product}
            productsPageRoute={productsPageRoute}
            sectionId={section.id}
          />
        )}
        <CriteoFopAnalytics isEnabled={isCriteoAdEnabled} fop={fop} />
      </div>
    );
  }
}
